import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const EASE = [0.22, 1, 0.36, 1];

/* Hero graphic: the seven frameworks as a connected stack — diagnostic on top, the six working frameworks beneath. */
export default function FrameworkStack({ frameworks }) {
  return (
    <div data-testid="frameworks-hero-graphic" className="relative border border-obsidian/20 bg-paper p-4 md:p-6">
      <span className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-obsidian/10" aria-hidden="true" />
      <ol className="relative space-y-2">
        {frameworks.map((f, i) => {
          const first = i === 0;
          return (
            <motion.li
              key={f.id}
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.3 + i * 0.09, ease: EASE }}
            >
              <a
                href={`#${f.id}`}
                data-testid={`stack-item-${f.id}`}
                className={`group grid grid-cols-[88px_1fr_auto] items-center gap-4 border px-4 py-3 transition-colors duration-300 md:px-5 ${
                  first ? "border-progress bg-progress text-white" : "border-obsidian/15 bg-white hover:border-obsidian"
                }`}
              >
                <span className={`text-xs font-bold uppercase tracking-[0.2em] ${first ? "text-white/80" : "text-slategray"}`}>{f.stage}</span>
                <span className="font-serif text-xl font-medium tracking-tight md:text-2xl">{f.name}</span>
                <span className={`text-xs font-bold uppercase tracking-[0.16em] ${first ? "text-white/80" : "text-progress"}`}>
                  {first ? "Start" : (f.used_in || []).join(" · ")}
                </span>
              </a>
            </motion.li>
          );
        })}
      </ol>
      <p className="mt-4 text-xs text-slategray">
        Letters mark the <Link to="/services" className="underline underline-offset-4 hover:text-progress">service series</Link> each framework powers.
      </p>
    </div>
  );
}
